// Qué modo va en cada sección — UNA lista para la home (los popups de "Redes sociales" y
// "Catálogos") y la sidebar (sus paneles de "Redes sociales", "Catálogo" y
// "Herramientas"), ADR-2026-10-05-la-sidebar-por-secciones.
//
// Cada modo vive en UNA sola sección. Los que dependen del rubro van todos en la lista y
// los filtra quien la dibuja con los flags del catálogo (un rubro ve uno u otro, nunca los
// dos: `plantillas` / `plantillas-belleza`, `catalogo` / `catalogo-muebles`).
//
// Fuera a propósito: Prompt libre, Creador de video y Automática (Crear hace lo de los dos
// primeros en una pantalla; ADR-2026-10-05-la-sidebar-por-secciones) y Anuncio
// (ADR-2026-10-05-anuncio-sale-de-toda-la-app). En el celular no hay sidebar y sus listas
// no salen de acá.

/** Crear y Recrear, en ese orden. */
export const MODOS_DE_REDES: readonly string[] = ['redes', 'plantillas', 'plantillas-belleza'];

/** Lo de la tienda, en el orden en que se muestran. */
export const MODOS_DE_CATALOGO: readonly string[] = [
  'modelo',
  'fotos-producto',
  'catalogo',
  'catalogo-muebles',
  'infografia',
  'mostrar-como-funciona-belleza',
];

/** Lo que todavía no existe y se anuncia como "Próximamente" al final del catálogo. */
export const PROXIMOS_DE_CATALOGO: readonly { nombre: string; bajada: string }[] = [
  { nombre: 'Videos cortos', bajada: 'Clips de tus productos para Mercado Libre' },
];

/**
 * Los MODOS de Herramientas. El panel abre con las ediciones rápidas
 * (`EDICIONES_RAPIDAS`, que no son modos sino atajos) y sigue con éstos. Carrusel y Animar
 * no van acá: ya están entre las ediciones rápidas.
 */
export const MODOS_DE_HERRAMIENTAS: readonly string[] = [
  'replicar-foto',
  'editor-video',
  'diseno-indumentaria',
  'flujos',
];

/**
 * Las carátulas con el fondo del tinte de su sección en vez del lavanda de siempre
 * (ADR-2026-10-05-caratulas-con-el-tinte-de-su-seccion): las usan los popups de la home y
 * los paneles de la sidebar. Son las mismas carátulas recoloreadas con
 * `scripts/caratulas-con-tinte/recolorear.py`. Una portada del rubro gana (es otra foto).
 */
export const CARATULAS_CON_TINTE: Readonly<Record<'redes' | 'catalogo', Readonly<Record<string, string>>>> = {
  redes: {
    // Crear todavía usa la de Prompt libre (prestada, ver `MODES`).
    redes: '/images/modo_prompt_libre/caratula_violeta.jpg',
    plantillas: '/images/modo_plantillas/caratula_violeta.jpg',
    // Belleza usa por ahora la misma carátula que las de Moda.
    'plantillas-belleza': '/images/modo_plantillas/caratula_violeta.jpg',
  },
  catalogo: {
    modelo: '/images/modo_con_modelo/caratula_amarilla.jpg',
    'fotos-producto': '/images/modo_fotos_producto/caratula_amarilla.jpg',
    catalogo: '/images/modo_catalogo_ia/caratula_amarilla.jpg',
  },
};
